export const EMPTY_CHAR = '-';
export const EMPTY_PLACEHOLDER = ' ';
